import axios from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useProgramTasksSetting() {
  // Use toast
  const toast = useToast()

  const saveTasks = queryParams => axios
    .post('/auth/save-tasks', queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Program Task was successfully updated',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Error saving program tasks',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    saveTasks,
  }
}
